import { DeliveryModes, PractitionerTypes, FacilityTypes } from './schema'

export const homeOnsiteVisitsServices = [
  {
    serviceId: 'HOME_001',
    serviceName: 'Home Consultation',
    category: 'Home & Onsite Visits',
    specialty: null,
    subCategory: 'Home Care',
    description: "Medical consultation provided at patient's home",
    cost: 650,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'HOME_CONSULT',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.MOBILE_UNIT],
    customisable: true,
    tags: ['home visit', 'consultation', 'house call'],
    displayOrder: 1
  },
  {
    serviceId: 'HOME_002',
    serviceName: 'Workplace Health Clinic',
    category: 'Home & Onsite Visits',
    specialty: 'Occupational Medicine',
    subCategory: 'Workplace Health',
    description: 'On-site health services at corporate workplace',
    cost: 800,
    durationMinutes: 60,
    deliveryModes: [DeliveryModes.WORKPLACE],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'WORKPLACE_CLINIC',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.MOBILE_UNIT],
    customisable: true,
    tags: ['workplace', 'corporate', 'onsite'],
    displayOrder: 2
  },
  {
    serviceId: 'HOME_003',
    serviceName: 'School Health Day',
    category: 'Home & Onsite Visits',
    specialty: 'Pediatrics',
    subCategory: 'School Health',
    description: 'Health screening and services provided at schools',
    cost: 300,
    durationMinutes: 30,
    deliveryModes: [DeliveryModes.WORKPLACE],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'SCHOOL_HEALTH',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.MOBILE_UNIT],
    customisable: true,
    tags: ['school', 'children', 'screening'],
    displayOrder: 3
  },
  {
    serviceId: 'HOME_004',
    serviceName: 'Home Nursing Care',
    category: 'Home & Onsite Visits',
    specialty: null,
    subCategory: 'Home Nursing',
    description: "Professional nursing care provided at patient's home",
    cost: 400,
    durationMinutes: 60,
    deliveryModes: [DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'HOME_NURSING',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC],
    customisable: true,
    tags: ['home nursing', 'care', 'bedside'],
    displayOrder: 4
  },
  {
    serviceId: 'HOME_005',
    serviceName: 'Mobile Blood Draw',
    category: 'Home & Onsite Visits',
    specialty: null,
    subCategory: 'Mobile Laboratory',
    description: "Blood collection service at patient's location",
    cost: 200,
    durationMinutes: 20,
    deliveryModes: [DeliveryModes.HOME_VISIT, DeliveryModes.WORKPLACE],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'MOBILE_BLOOD',
    billableItems: [
      {
        itemId: 'BLOOD_001',
        itemName: 'Blood collection supplies',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.DIAGNOSTIC_CENTER],
    customisable: true,
    tags: ['mobile', 'blood draw', 'laboratory'],
    displayOrder: 5
  },
  {
    serviceId: 'HOME_006',
    serviceName: 'Emergency Home Visit',
    category: 'Home & Onsite Visits',
    specialty: null,
    subCategory: 'Emergency Care',
    description: "Emergency medical care provided at patient's home",
    cost: 900,
    durationMinutes: 60,
    deliveryModes: [DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'EMERGENCY_HOME',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.MOBILE_UNIT],
    customisable: true,
    tags: ['emergency', 'home visit', 'urgent'],
    displayOrder: 6
  }
]

export default homeOnsiteVisitsServices
